import { Component, Input, OnInit } from '@angular/core';
import { Session } from '@models/Sessions/Session';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BusService } from '@services/bus.service';
import { EventsService } from '@services/events.service';
import { PdfReportService } from '@services/sessions/pdfreport.service';
import { SessionsRequestService } from '@services/sessions/sessions.request.service';
import _ from 'lodash';

@Component({
  selector: 'app-sessions-import-wizard-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ImportWizardModalComponent implements OnInit {
  @Input() session: Session;

  files = [];
  importData = [];
  filesProcessing = 0;

  constructor(
    private activeModal: NgbActiveModal,
    private bus: BusService,
    private events: EventsService,
    private pdfReport: PdfReportService,
    private sessionRequest: SessionsRequestService,
  ) {}

  filesChange(event) {
    const files = event.srcElement.files;
    this.filesProcessing = files.length;
    this.files = files;
  }

  import() {
    if (this.files.length) {
      _.forEach(this.files, file => {
        const reader = new FileReader();
        reader.readAsText(file, 'application/json;charset=utf-8');
        reader.onload = event => {
          this.importData.push(JSON.parse((event.target as any).result));
          this.filesProcessing--;
          if (this.filesProcessing === 0) {
            // All done, send importData to server
            this.bus.publish(
              this.events.requested.action.session.import,
              this.importData,
              this.session,
            );
            this.bus.publish(
              this.events.requested.data.session.single,
              this.session._id,
            );
          }
        };
      });
    } else {
      this.activeModal.close();
    }
  }

  importSuccess() {
    this.activeModal.close();
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  ngOnInit() {
    this.bus.subscribe(
      this.events.received.action.session.import.success,
      this.importSuccess.bind(this),
    );
  }
}
